import React, { useRef, useEffect } from 'react';
import { view } from '@aha-app/react-easy-state';

const EditablePrompt = ({ prompt }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <div>
      <label className='control-label'>{prompt.title}</label>
      <div className='form-inline'>
        <input
          ref={inputRef}
          type='text'
          className='input-xxlarge'
          value={prompt.value}
          placeholder={prompt.options.placeholder}
          onChange={e => (prompt.value = e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.stopPropagation();
              prompt.save();
            }
          }}
        />
        &nbsp;
        <button className='btn btn-primary' onClick={() => prompt.save()}>
          Enter
        </button>
      </div>
    </div>
  );
};

export default view(EditablePrompt);
